module.exports = __webpack_public_path__ + "static/media/homepage-faq-section-background.8cf0affe.png";